/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-underscore-dangle */
import { createSelector } from '@reduxjs/toolkit';
import { initialState } from './slice';
//
const selectDomain = (state) => state['feature/hotels'] || initialState;
/**
 * Getting loader state to hotel component
 */
export const selectLoader = createSelector([selectDomain], (hotelState) => hotelState.loading);
/**
 * Getting hotel state to hotel component
 */
export const selectHotels = createSelector([selectDomain], (hotelState) => hotelState.hotels);
/**
 * Getting the filtered hotel by hotel id state into the component
 */
const getFirstParam = (_, param) => param;
export const selectHotelById = createSelector(
  [selectHotels, getFirstParam],
  (selectedHotels, hotelId) => selectedHotels?.filter((hotel) => hotel.id === hotelId)[0]
);
/**
 * Getting currency data state to hotel component
 */
export const selectCurrencyData = createSelector(
  [selectDomain],
  (hotelState) => hotelState.currencyData
);
/**
 * Getting users assigned to a specific hotel to the component
 */
export const selectHotelUsers = createSelector(
  [selectDomain],
  (hotelState) => hotelState.hotelUsers
);
